import { useRouterExternal } from 'common/hooks/useRouterExternal';
import { setCookies } from 'common/method/helper';
import OtpModule from 'common/modules/OtpPage';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useTwoFactorAuthorization } from 'services/login';

const TwoStepPage = () => {
  const { pushExternal } = useRouterExternal();
  const { t } = useTranslation();


  //* submit twoFactor
  const { mutate: mutateTwoStep } = useTwoFactorAuthorization({
    onSuccess: (data) => {
      const {
        succeeded,
        result: { token, callBackUrl, loginResultType },
      } = data;
      if (succeeded) {
        setCookies(token);
        pushExternal(callBackUrl, token);
        return
      }
      if (loginResultType) {
        toast.error(t('Errors.' + loginResultType));
      }
    },
  });

  const handleSubmitOtp = (data: ISubmitOtpModuleType) => {
    mutateTwoStep(data);
  };

  return <OtpModule {...{ handleSubmitOtp }} />;
};

export default TwoStepPage;
